@if (partners && distributors) {
  <form class="form-example mt-3">
    <div nxLayout="grid">
      <div nxRow="">
        @if (model.measuringPoint) {
          <div nxCol="12,12,12,12">
            <nx-formfield label="{{'contract.point' | caption}}">
              <input type="text" nxInput disabled
                [value]="model.measuringPoint.name"/>
              </nx-formfield>
            </div>
          }
          <div nxCol="12,12,12,6">
            <nx-formfield label="{{'contract.partner' | caption}}">
              <nx-dropdown
                name="partnerId"
                [(ngModel)]="model.partnerId"
                (ngModelChange)="updatePartner($event)"
                >
                @for (partner of partners; track partner.id) {
                  <nx-dropdown-item [value]="partner.id"> {{partner.name}}</nx-dropdown-item>
                }
              </nx-dropdown>
            </nx-formfield>
          </div>
          <div nxCol="12,12,12,6">
            <nx-formfield label="{{'general.distributor' | caption}}">
              <nx-dropdown
                name="distributorId"
                [(ngModel)]="model.distributorId"
                (ngModelChange)="updateDistributor($event)"
                >
                @for (distributor of distributors; track distributor.id) {
                  <nx-dropdown-item [value]="distributor.id"> {{distributor.name}}</nx-dropdown-item>
                }
              </nx-dropdown>
            </nx-formfield>
          </div>
          <div nxCol="12,12,12,6">
            <nx-formfield label="{{'contract.start' | caption}}">
              <input name="start" type="local-datetime" nxInput nxDatefield [datepicker]="startDatePicker"
                (dateChange)="updateEndDatepicker()"
                [datefieldFilter]="denyDateFilter"
                [(ngModel)]="model.start" required/>
                <nx-datepicker-toggle
                  [for]="startDatePicker"
                  nxFormfieldSuffix
                ></nx-datepicker-toggle>
                <nx-datepicker #startDatePicker></nx-datepicker>
              </nx-formfield>
            </div>
            <div nxCol="12,12,12,6">
              <nx-formfield label="{{'contract.end' | caption}}">
                <input name="end" type="datetime" nxInput nxDatefield [datepicker]="endDatePicker" [min]="minDate" [disabled]="!minDate"
                  [datefieldFilter]="denyDateFilter"
                  [(ngModel)]="model.end" required/>
                  <nx-datepicker-toggle
                    [for]="endDatePicker"
                    nxFormfieldSuffix
                  ></nx-datepicker-toggle>
                  <nx-datepicker #endDatePicker></nx-datepicker>
                </nx-formfield>
              </div>
              <div nxCol="12,12,12,6">
                <nx-formfield label="{{'addon.chartType' | caption}} *">
                  <nx-multi-select [(ngModel)]="model.chartTypes" name="chartTypes"
                    [options]="chartTypes" selectValue="id" selectLabel="label"
                  ></nx-multi-select>
                </nx-formfield>
              </div>
              <div nxCol="12" class="nx-margin-top-s">
                <nx-message context="info">
                  <span class="nx-font-weight-bold">{{'general.info' | caption}}</span><br/>
                  @if (model.measuringPoint) {
                    <span>  {{'contract.selectDateToContinue' | caption}}</span>
                  }
                  @if (!model.measuringPoint) {
                    <span>  {{'contract.selectDateToContinue2' | caption}}</span>
                  }
                  <br/>
                  <button (click)="loadDeviceAndPoint()" nxButton="secondary small" class="nx-margin-top-s">
                    <nx-icon name="check"></nx-icon>
                    {{'contract.dateIsOk' | caption}}
                  </button>
                </nx-message>
              </div>
              @if (model.start && model.end && measuringDevices) {
                <div nxCol="12,12,12,6">
                  <nx-formfield label="{{'contract.device' | caption}}">
                    <nx-dropdown
                      name="measuringDeviceId"
                      (ngModelChange)="updateDevice($event)"
                      [(ngModel)]="model.measuringDeviceId"
                      >
                      @for (device of measuringDevices; track device.id) {
                        <nx-dropdown-item [value]="device.id"> {{device.uuId}}</nx-dropdown-item>
                      }
                    </nx-dropdown>
                  </nx-formfield>
                </div>
              }
              @if (model.start && model.end && measuringPoints && !model.measuringPoint) {
                <div nxCol="12,12,12,6">
                  <nx-formfield label="{{'contract.point' | caption}}">
                    <nx-dropdown
                      name="measuringDeviceId"
                      [(ngModel)]="model.measuringPointId"
                      >
                      @for (point of measuringPoints; track point.id) {
                        <nx-dropdown-item [value]="point.id"> {{point.name}}</nx-dropdown-item>
                      }
                    </nx-dropdown>
                  </nx-formfield>
                </div>
              }
            </div>
          </div>
        </form>
      }
      <!--  <ng-container *ngIf="measuringPoints.length<1 || measuringDevices.length<1">-->
      <!--    <nx-message context="info">-->
      <!--      <span class="nx-font-weight-bold">{{'general.info' | caption}}</span><br/>-->
      <!--      {{'contract.canNotCreate' | caption}}-->
      <!--      <ul class="nx-margin-left-2m">-->
      <!--        <li *ngIf="!measuringDevices || measuringDevices.length<1">{{'contract.noDevice' | caption}}</li>-->
      <!--        <li *ngIf="!measuringPoints || measuringPoints.length<1">{{'contract.noPoint' | caption}}</li>-->
    <!--      </ul>-->
  <!--    </nx-message>-->
<!--  </ng-container>-->
